import script from "./manage.vue?vue&type=script&setup=true&lang=js"
export * from "./manage.vue?vue&type=script&setup=true&lang=js"

import "./manage.vue?vue&type=style&index=0&id=2b20d59c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b20d59c"]])

export default __exports__